export default __webpack_public_path__ + "static/media/arrow_down.e867490c.svg";